import axios, { AxiosPromise } from 'axios'
import { EmitirAssinaturaDigitalInput } from 'hooks/assinatura-digital/model-assinaturaDigitalPopup'
import {
  BaixarAtendimentoDigitalInput,
  GerarAtendimentoDigitalInput,
} from 'view/assinatura-eletronica-atend/model-assinaturaEletronicaAtend'

export class AtendimentoDigital {
  gerarAtendimentoDigital(input: GerarAtendimentoDigitalInput): AxiosPromise<string> {
    return axios.post('/api/assinatura-digital/gerarAtendimentoDigital', input, { responseType: 'text' })
  }

  emitirAtendimentoDigital(input: EmitirAssinaturaDigitalInput): AxiosPromise<void> {
    return axios.post('/api/assinatura-digital/emitirAtendimentoDigital', {
      atendimentoProfissionalId: input.atendimentoId,
      codigoDocumento: input.codigoDocumento,
    })
  }

  baixarAtendimentoDigital(params: BaixarAtendimentoDigitalInput): AxiosPromise<Blob> {
    return axios.get<Blob>('/api/assinatura-digital/baixarAtendimentoDigital', { params, responseType: 'blob' })
  }
}
